export function toBase64(file: File, callback: (result: string) => void) {
  if (window.FileReader) {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onloadend = function () {
      if (reader.result && typeof reader.result === 'string') {
        callback(reader.result);
      }
    };
  }
}
export const fileToBase64 = (file: File) =>
  new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
